import styled from "styled-components";
import iconCalendar from "../../assets/icons/icons8-calendário-16.png"
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    min-height: 100vh;

    display: flex;
    align-items: center;
    flex-direction: column;

    background-color: white;
`

export const ContainerSearchBody = styled.div`
    width: 100%;
    height: 90%;
    max-width: 1036px;
    padding: 1rem 2rem;
    
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 760px) {
        padding: 1rem;
    }
`

export const SearchBody = styled.div`
    width: 100%;
    height: 90%;
    max-width: 1038px;
    
    /* padding: 1.5rem 2rem; */
    display: flex;
    gap: 1.5rem;

    .listContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 1130px) {
        flex-direction: column;
    }
`

export const ContainerFilterChindren = styled.div`
    width: auto;
    height: auto;
    padding: 5px 5px;

    gap: 8px;
    display: flex;
    flex-direction: column;

    >div>div>input{
        padding-right: 1rem;
    }
`;

export const SearchHistoryArea = styled.div`
    gap: 1rem;
    width: 100%;
    display: flex;

    margin-bottom: 1rem;

    div {
        width: 100%;
        max-width: 100%;
    }

    @media (max-width: 920px) {
        gap: 0.5rem;
        align-items: center;
        flex-direction: column;
        margin-bottom: 1rem;
    }
`

export const FormButton = styled.button`
    all: unset;
    position: relative;

    height: 1.5rem;
    width: 100%;
    max-width: 13.6875rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    border-radius: 10rem;
    background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : `${theme.colors.green.Verde_AgroReceita}`)}; 

    transition: background-color 0.3s ease, color 0.3s ease; 

    >p{
        text-transform: uppercase;
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

        color: ${({ disabled }) => (disabled ? '#AAAAAA' : '#FFFFFF')};
        
        transition: color 0.3s ease;
    }

    >img{
        height: auto;
        width: 1.25rem;
        cursor: pointer;
        transform: rotate(90deg);
        transition: filter 0.3s ease; 
        filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')}; 
    }

    &:hover {
        background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : '#259D57')};
    }
`;

export const Accordion = styled.div`
    top: 100%;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    margin-top: 0.5rem;

    z-index: 10;
    width: 10rem;  

    display: flex;
    flex-direction: column;

    background: #fff;
    border-radius: 0.5rem; 
    border: 0.0625rem solid #ddd;
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);  

    > button, > div {
        all: unset;
        
        padding: 0.5rem 1rem;  

        display: flex;
        justify-content: center;

        color: ${theme.colors.gray.Cinza_2};
        cursor: pointer;
        font-size: 0.625rem; 

        &:hover {
          background-color: #f5f5f5;
        }
    }

    > div {
        cursor: default;
        
        &:hover {
          background-color: transparent;
        }
    }

    @media (max-width: 769px) {
        right: -0.9125rem; 
        left: auto;
        transform: none;
    }
`;

export const List = styled.div``

export const Data = styled.div`
    width: 296px;
    height: 50px;
    border-radius: 25px;
    background-color: #f3f3f5;
    display: flex;
    justify-content: center;
    align-items: center;


    .input-data-filter{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .input-date{
            border: none;
            border-right: 1px;
            background-color: #f3f3f5;
            padding-right: 25px;
            height: 40px;
        }

        .input-date + .input-date{
            border-left: solid 1px #dfe4eb;
            padding-left: 25px;
            padding-right: 0px;
        }

        input[type="date"]::-webkit-calendar-picker-indicator{
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            background: url(${iconCalendar}) no-repeat;
            border-width: thin;
            margin-top: 5px;
        }

        input[type="date"]::-webkit-inner-spin-button{
            margin-top: 8px;
        }

    }
`;

export const ContainerItemNotFound = styled.div`
    width: 100%;
    height: calc(100vh - 21.05rem);

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
   
   >img{
    width: 100%;
    height: auto;
    max-width: 150px;
   }
`;

export const ContainerLoading = styled.div`
    width: 100%;
    height: 20rem;
    
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 88px;
  height: 88px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Bandeira};
  border-bottom: 1px solid ${theme.colors.green.Bandeira};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;

export const ModalPlanBlockContainer = styled.div`
  width: 100%;
  height: auto;
  max-width: 28.75rem;

  >img{
      @media (max-width: 480px) {
            width: 8rem;
      }
    }

  >h5{
      margin-top: 1rem;

      @media (max-width: 480px) {
          font-size: 1.4rem;
      }
  }

  >p{
     margin-top: 1rem;

      >span{
        @media (max-width: 480px) {
          font-size: 1rem;
        }
      }

     @media (max-width: 480px) {
          font-size: 1rem;
      }
  }

  >p:nth-of-type(2){
      margin-top: 0.5rem;

      @media (max-width: 480px) {
            font-size: 0.9rem;
            line-height: 1rem;
      }
  }

    >div >div {
        >div:nth-of-type(1) {}

        >div:nth-of-type(2) {
          margin-bottom: 0;      
        }
    }
`;

export const ModalPlanBlockButtonPlans = styled.div`
     width: 100%;
     display: flex;
     margin-top: 1.25rem;
     margin-bottom: 0.938rem;
     flex-direction: row;
     justify-content: center; 
`;